module.exports = __webpack_public_path__ + "img/icon-fields.48e7726c.svg";